import React, { useRef, useEffect, useState } from 'react';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import SignaturePad from '../../../components/FormBuilder/InputComponents/signature_pad';
import { FieldLabel, Description, RequiredMsg } from '../FieldLabel';
import { CueTip } from '../../../components/Common/CueTooltip';

let signaturePad = null;
const InputSignaturePad = ({renderField, position, field, formData, readOnly, errors, formFn, isFormWizard, openFieldLabelModal, currentLocale}) => {
  
  const clientId = field.client_id;
  //importScript("/node_modules/signature_pad/dist/signature_pad.min.js");

  const inputEl = useRef(null);
  let [showError, setShowError] = useState(false);

  useEffect(() => {
    setCanvas();
  }, [field.client_id]);
  
  if(!renderField){
    return null
  }

  /* let inputAttributes = {
    'name': clientId,
    'placeholder': field.placeholder,
    'disabled': readOnly
  } */
  
  let parentAttributes = {
    'tooltip': field.tooltip,
    'id': clientId
  }
  
  //FormHelper.setDisabled(field, inputAttributes);
  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);
  //FormHelper.checkFieldValidity(field, formData, errors);

  const save_png = () => {
    let data = signaturePad.toDataURL('image/png');
    formData[clientId] = data;
    //setData(data);
    //var file = dataURLtoFile(data, 'signature.png');
    //uploadFileToUrl(file)
  }

  const setCanvas = () => {
    signaturePad = new SignaturePad(inputEl.current, {
      backgroundColor: 'rgb(255, 255, 255)',
      onEnd: save_png
    })
    setError();
  }

  const clear = (e) =>{
    e.stopPropagation();
    if(formData[clientId]){
      //removeImage($scope.sign);
      formData[clientId] = null;
    }
    signaturePad.clear();
    setError();
  }

  const setError = () => {
    if(field.required){
      errors[clientId].invalid = formData[clientId]==null?true:false;
      errors[clientId].touched = true;
      if(errors[clientId].invalid){
        errors.invalid[clientId] = true;
      }else{
        delete errors.invalid[clientId]
      }
      setShowError(!showError);
      formFn.refreshFormSubmit();
    }
  }
  
  const Error = () => {
    if(field.required && (errors[clientId].touched || errors.isSubmitted) && errors[clientId].invalid){
      return(
        <div className="errormsg">
          <div>
            <span className="fas fa-exclamation-triangle m-r-5"/>
            <RequiredMsg {...{field, currentLocale}}/>
          </div>
        </div>
      )
    }
    return null;
  }

  return (
  	<div {...parentAttributes}>
      <div className="flex coldir m-b-20 tooltip">
        <CueTip 
          positionCss={position>1?'top':'bottom'}
          tooltip={field.tooltip}
          currentLocale={currentLocale}
          locale={field.locale?.tooltip}/>
    	  <FieldLabel field={field} 
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes} 
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal}/>
   	    <div className="wrapper br-black br-grey">
          <canvas ref={inputEl} className="signature-pad" width="400" height="200"></canvas>
          <button type="button" onClick={e=>{clear(e)}} className="butn btn-inverse pull-right">Clear</button>
        </div> 	 
        <Description description={field.description} currentLocale={currentLocale}
          locale={field.locale?.description} />
        <Error/>
 	    </div>
    </div> 
  )
}

export default InputSignaturePad;